import { Switch, Route } from "react-router-dom";
import ModuloADS from "../../Pages/ModuloAds";
import AnaliseDeCredito from "../../Pages/Vendas/AnaliseDeCredito";
import AtendimentoVendas from "../../Pages/Vendas/AtendimentoVendas";
import { GestaoAtendimentoVendas } from "../../Pages/Vendas/GestaoAtendimentos";
import GestaoDeVisitas from "../../Pages/Vendas/GestaoDeVisitas";
import GestaoConfigDeEnvelope from "../../Pages/Vendas/GestaoConfigDeEnvelope";
import GestaoReservas from "../../Pages/Vendas/GestaoReservas";
import PainelImplantacao from "../../Pages/Vendas/PainelImplantacao";
import { ACESSOS } from "../Acessos";
import PrivatedRoute from "../PrivatedRoute";
import EspelhoVendas from "../../Pages/Vendas/EspelhoVendas";
import GestaoCadastro from "../../Pages/Vendas/GestaoDeCadastro";
import GestaoVistoriaEquipeProduto from "../../Pages/Vendas/GestaoVincularProdutos";
import CriarNovoLeadVendas from "../../Pages/Vendas/GestaoLeads/CriarNovoLead/CriarNovoLead";
import RelatorioBIVendasLead from "../../Pages/Vendas/RelatoriosBI/RelatorioBIVendasLead/RelatorioBIVendasLead";
import RelatorioBIVendasVisita from "../../Pages/Vendas/RelatoriosBI/RelatorioBIVendasVisita/RelatorioBIVendasVisita";
import RelatorioBIVendasAnaliseCredito from "../../Pages/Vendas/RelatoriosBI/RelatorioBIVendasAnaliseCredito/RelatorioBIVendasAnaliseCredito";
import RelatorioBIVendas from "../../Pages/Vendas/RelatoriosBI/RelatorioBIVendas/RelatorioBIVendas";
import RelatorioBIVendasEstoque from "../../Pages/Vendas/RelatoriosBI/RelatorioBIVendasEstoque/RelatorioBIVendasEstoque";
import RelatorioBIVendasMarketing from "../../Pages/Vendas/RelatoriosBI/RelatorioBIVendasMarketing/RelatorioBIVendasMarketing";
import RelatorioBIVendasPerdas from "../../Pages/Vendas/RelatoriosBI/RelatorioBIVendasPerdas/RelatorioBIVendasPerdas";
import EtapasGrupo from "../../Pages/Repasse/EtapasGrupo";
import AgendaAtividadesComponent from "../../Pages/Geral/Agenda/Agenda";
import PainelResumo from "../../Pages/Geral/PainelResumoVendedor/PainelResumoVendedor";
import PesquisaSatisfacaoVendas from "../../Pages/Vendas/PesquisaSatisfacaoVendas/PesquisaSatisfacaoVendas";
import GestaoProdutoVendas from "../../Pages/Vendas/GestaoProdutos/GestaoProdutos";
import MapaImplantacao from "../../Pages/Vendas/GestaoProdutos/MapaImplantacao/MapaImplantacao";
import GestaoProdutos from "../../Pages/Geral/GestaoProdutos";
import CadastrarProduto from "../../Pages/Geral/GestaoProdutos/CadastrarProduto";
import EditarProduto from "../../Pages/Geral/GestaoProdutos/EditarProduto";
// import RelatorioBIVendasGestaoAtendimento from "../../Pages/Vendas/RelatoriosBI/RelatorioBIVendasGestaoAtendimento/RelatorioBIVendasGestaoAtendimento";

export default function RotasVendas() {
    return (
        <Switch>
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.DASHBOARD.DS_PATH}
                component={() => <></>}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.DASHBOARD.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.TODOS.DS_PATH}
                component={GestaoAtendimentoVendas.TodosAtendimentos}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.TODOS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.GRUPO.DS_PATH}
                component={GestaoAtendimentoVendas.GrupoAtendimentos}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.GRUPO.ID_TELA}
            />
            <PrivatedRoute
                path={
                    ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.MEUS_ATENDIMENTOS
                        .DS_PATH
                }
                component={GestaoAtendimentoVendas.MeusAtendimentos}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={
                    ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.MEUS_ATENDIMENTOS
                        .USUARIO.ID_TELA
                }
            />
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.ANALISE_CREDITO.DS_PATH}
                component={AnaliseDeCredito}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.ANALISE_CREDITO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.GESTAO_RESERVAS.DS_PATH}
                component={GestaoReservas}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.GESTAO_RESERVAS.ID_TELA}
            />
            <PrivatedRoute
                path={
                    ACESSOS.VENDAS.TELAS.GESTAO_CADASTRO.CRIAR_EQUIPE_VENDA
                        .DS_PATH
                }
                component={GestaoCadastro}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={
                    ACESSOS.VENDAS.TELAS.GESTAO_CADASTRO.CRIAR_EQUIPE_VENDA
                        .ID_TELA
                }
            />
            <PrivatedRoute
                path={
                    ACESSOS.VENDAS.TELAS.GESTAO_CADASTRO.VINCULAR_PRODUTO_VENDA
                        .DS_PATH
                }
                component={GestaoVistoriaEquipeProduto}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={
                    ACESSOS.VENDAS.TELAS.GESTAO_CADASTRO.VINCULAR_PRODUTO_VENDA
                        .ID_TELA
                }
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.PRODUTOS.TELAS.PAINEL_IMPLANTACAO.DS_PATH}
                component={PainelImplantacao}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={
                    ACESSOS.VENDAS.PRODUTOS.TELAS.PAINEL_IMPLANTACAO.ID_TELA
                }
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.GESTAO_VISITAS.DS_PATH}
                component={GestaoDeVisitas}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.GESTAO_VISITAS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.ATENDIMENTO.DS_PATH}
                component={AtendimentoVendas}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.ATENDIMENTO.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.ESPELHO_VENDAS.DS_PATH}
                component={EspelhoVendas}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.ESPELHO_VENDAS.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.GESTAO_CONFIG_ENVELOPES.DS_PATH}
                component={GestaoConfigDeEnvelope}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.GESTAO_CONFIG_ENVELOPES.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.GESTAO_LEADS.CADASTRO_LEAD.DS_PATH}
                component={CriarNovoLeadVendas}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.GESTAO_LEADS.CADASTRO_LEAD.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.RELATORIOS_BI_LEADS.DS_PATH}
                component={RelatorioBIVendasLead}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.RELATORIOS_BI_LEADS.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.RELATORIOS_BI_VISITA.DS_PATH}
                component={RelatorioBIVendasVisita}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.RELATORIOS_BI_VISITA.ID_TELA}
            />
            <PrivatedRoute
                path={
                    ACESSOS.VENDAS.TELAS.RELATORIOS_BI_ANALISE_CREDITO.DS_PATH
                }
                component={RelatorioBIVendasAnaliseCredito}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={
                    ACESSOS.VENDAS.TELAS.RELATORIOS_BI_ANALISE_CREDITO.ID_TELA
                }
            />
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.RELATORIOS_BI_VENDAS.DS_PATH}
                component={RelatorioBIVendas}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.RELATORIOS_BI_VENDAS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.RELATORIOS_BI_ESTOQUE.DS_PATH}
                component={RelatorioBIVendasEstoque}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.RELATORIOS_BI_ESTOQUE.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.RELATORIOS_BI_PERDAS.DS_PATH}
                component={RelatorioBIVendasPerdas}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.RELATORIOS_BI_PERDAS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.RELATORIOS_BI_MARKETING.DS_PATH}
                component={RelatorioBIVendasMarketing}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.RELATORIOS_BI_MARKETING.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.GESTAO_CADASTRO.ETAPAS_GRUPO.DS_PATH}
                component={EtapasGrupo}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={
                    ACESSOS.VENDAS.TELAS.GESTAO_CADASTRO.ETAPAS_GRUPO.ID_TELA
                }
            />

            {/* <PrivatedRoute
                path={
                    ACESSOS.VENDAS.TELAS.RELATORIOS_BI_GESTAO_ATENDIMENTO
                        .DS_PATH
                }
                component={RelatorioBIVendasGestaoAtendimento}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={
                    ACESSOS.VENDAS.TELAS.RELATORIOS_BI_GESTAO_ATENDIMENTO
                        .ID_TELA
                }
            /> */}

            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.GESTAO_ATIVIDADES.DS_PATH}
                component={AgendaAtividadesComponent}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.GESTAO_ATIVIDADES.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.PAINEL_RESUMO.DS_PATH}
                component={PainelResumo}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.PAINEL_RESUMO.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.PESQUISA_SATISFACAO.DS_PATH}
                component={PesquisaSatisfacaoVendas}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.PESQUISA_SATISFACAO.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.GESTAO_PRODUTOS.DS_PATH}
                component={GestaoProdutoVendas}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.GESTAO_PRODUTOS.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.MAPA_IMPLANTACAO.DS_PATH}
                component={MapaImplantacao}
                isPrivate
                idModulo={ACESSOS.VENDAS.ID_MODULO}
                idTela={ACESSOS.VENDAS.TELAS.MAPA_IMPLANTACAO.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.GESTAO_PRODUTOS_VENDAS.DS_PATH}
                exact
                component={GestaoProdutos}
                isPrivate
                idTela={ACESSOS.VENDAS.TELAS.GESTAO_PRODUTOS_VENDAS.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.CADASTRO_PRODUTO.DS_PATH}
                component={CadastrarProduto}
                isPrivate
                idTela={ACESSOS.VENDAS.TELAS.CADASTRO_PRODUTO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.EDITAR_PRODUTO.DS_PATH}
                component={EditarProduto}
                isPrivate
                idTela={ACESSOS.VENDAS.TELAS.EDITAR_PRODUTO.ID_TELA}
            />

            <Route path="/Vendas/:idModulo/" exact component={ModuloADS} />
        </Switch>
    );
}
